import React, {Component} from 'react';
import {
    Box,
    Button,
    Checkbox, Chip,
    Paper,
    Table, TableBody, TableCell,
    TableContainer,
    TableHead,
    TableRow, Typography, Avatar, IconButton
} from "@material-ui/core";
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import PaginationComponent
    from "../../../../Components/PaginationComponent/PaginationComponent";
import {
    ContentContainerChartStyled,
    ContentContainerTotalizeStyled,
    ContentParentTotalizeStyled
} from "./styled";
import TotalizeTableCompaignMetaComponent
    from "./TotalizeTableCompaignMetaComponent";
import ChartDefault from "../../DashboardScreen/ChartDefault";
import GoalService from "../../../../Services/GoalService";
import DeleteIcon from '@material-ui/icons/Delete';
import TextFieldDefault
    from "../../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import {SearchOutlined} from "@material-ui/icons";
import {
    SearchTextFieldStyled
} from "../../NewAward/SubHeaderAward/SearchTextFieldComponent/styled";

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import {CheckCircleIconStyled} from "../styled";

class TableCampaignMetaComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectUserToShowDashboard: null,
            eligibleClients: null,
            pagination: null,
            selectClients: [],
        };

        this.goalService = new GoalService();
    }

    componentDidMount() {
        this.getEligibleClients({page: 1});
    }


    async getEligibleClients({page = 1}) {
        try {
            console.log('getEligibleClients');
            const response = await this.goalService.eligibleClients({
                companyUuid: this.props.companyUuid,
                page: page,
                search: this.state.search,
            });


            this.setState({
                eligibleClients: response.data.data,
                pagination: response.data.meta,
            });

        } catch (e) {
            throw e;
        }
    }

    makeRowTable() {
        const rows = [];
        const context = this;
        const numberOfColumns = 10; // Total de colunas na sua tabela


        if (!context.state?.eligibleClients) {
            return <></>;
        }

        Object.keys(context.state?.eligibleClients).forEach(function (key, index) {
            const value = context.state?.eligibleClients[key];

            const isChecked = context.state.selectClients.some(
                item => item.client.uuid === value.client.uuid
            );

            const weeklyAvgRounded = Math.round(Number(value.weekly_avg ?? 0));
            const monthlyAvgRounded = Math.round(Number(value.monthly_avg ?? 0));

            rows.push(
                <React.Fragment key={value.client.uuid || index}>
                    <TableRow>
                        <TableCell>
                            <Checkbox checked={isChecked}
                                      disabled={value?.goals.length}
                                      onChange={() => context.selectClients(value)}
                                      color={'primary'}/>
                        </TableCell>
                        <TableCell onClick={() => context.setState({
                            selectUserToShowDashboard: value.client.uuid,
                        })}>
                            <Typography color={'primary'}>
                                <b>{value.client.name}</b>
                            </Typography>
                        </TableCell>
                        <TableCell>{value.client.cpf}</TableCell>
                        <TableCell>{value?.goals.length ?
                            <CheckCircleIconStyled/> :
                            <CancelIcon color={'error'}/>} </TableCell>
                        <TableCell>{weeklyAvgRounded}</TableCell>
                        <TableCell>{monthlyAvgRounded}</TableCell>
                        <TableCell>{value.total_points_12_months}</TableCell>
                    </TableRow>
                    {context.state.selectUserToShowDashboard === value.client.uuid &&
                        <TableRow>
                            <TableCell colSpan={numberOfColumns}>
                                <ContentParentTotalizeStyled>
                                    <ContentContainerTotalizeStyled>
                                        <TotalizeTableCompaignMetaComponent
                                            title={'Média semanal'}
                                            total={Math.round(Number(value?.metrics?.media_semanal ?? 0))}/>
                                        <TotalizeTableCompaignMetaComponent
                                            title={'Média quinzenal'}
                                            total={Math.round(Number(value?.metrics?.media_quinzenal ?? 0))}/>
                                        <TotalizeTableCompaignMetaComponent
                                            title={'Média mensal'}
                                            total={Math.round(Number(value?.metrics?.media_mensal ?? 0))}/>
                                        <TotalizeTableCompaignMetaComponent
                                            title={'Última semana'}
                                            total={Math.round(Number(value?.metrics?.ultima_semana ?? 0))}/>
                                        <TotalizeTableCompaignMetaComponent
                                            title={'Última quinzenal'}
                                            total={Math.round(Number(value?.metrics?.ultima_quinzena ?? 0))}/>
                                        <TotalizeTableCompaignMetaComponent
                                            title={'Última mensal'}
                                            total={Math.round(Number(value?.metrics?.ultima_mensal ?? 0))}/>
                                    </ContentContainerTotalizeStyled>
                                    <SpacerComponent height={20}/>
                                    <ContentContainerChartStyled>
                                        <ChartDefault
                                            showGrid={false}
                                            elevation={1}
                                            title={'Volume de compras in 12 meses'}
                                            data={context.createChartData(value.chart)}/>
                                    </ContentContainerChartStyled>
                                </ContentParentTotalizeStyled>
                            </TableCell>
                        </TableRow>
                    }
                </React.Fragment>
            );
        });

        return rows;
    }

    createChartData(data) {
        return (data ?? []).map(item => ({
            description: item?.label ?? '',
            count: item?.total ?? 0,
        }));
    }

    selectClients(clients) {
        const currentClients = this.state.selectClients;

        const filteredClients = currentClients.filter(item => item.client.uuid !== clients.client.uuid);

        if (filteredClients.length < currentClients.length) {
            this.setState({selectClients: filteredClients});
            return;
        }

        this.setState({
            selectClients: [...currentClients, clients]
        });
    }

    makeChipsForClientsSelected() {
        const selectedList = this.state.selectClients;

        // Se não houver clientes selecionados, retorna um array vazio imediatamente
        if (!selectedList || selectedList.length === 0) {
            return [];
        }

        // Mapeia o array do estado transformando cada cliente em um componente <Chip />
        return selectedList.map((item, index) => {
            // Pega a primeira letra do nome para o Avatar (ex: Fabio -> F)
            const firstLetter = item.client.name ? item.client.name.charAt(0).toUpperCase() : 'C';

            return (
                <Chip
                    key={item.client.uuid || index}
                    avatar={<Avatar>{firstLetter}</Avatar>}
                    label={item.client.name}
                    clickable
                    color="primary"
                    // Ao clicar no 'X', chama a função que já criamos para remover do estado
                    onDelete={() => this.selectClients(item)}
                    deleteIcon={<DeleteIcon/>}
                    style={{
                        marginRight: 8,
                        marginBottom: 8
                    }} // Opcional: espaçamento entre os chips
                />
            );
        });
    }

    getClientUuids() {
        return this.state.selectClients.map(item => item.client.uuid);
    }

    render() {
        return (
            <div>
                <SearchTextFieldStyled label="Buscar"
                                       variant="outlined"
                                       name={'search'}
                                       onChange={(event) => this.state.search = event.target.value}
                                       InputProps={{
                                           endAdornment: <IconButton
                                               onClick={() => {
                                                   console.log('search');
                                                   this.getEligibleClients({page: 1})
                                               }}>
                                               <SearchOutlined/>
                                           </IconButton>
                                       }}
                />
                <SpacerComponent height={10}/>
                <Typography variant={'subtitle1'}>
                    {this.state.selectClients.length > 0
                        ? 'Clientes selecionados:'
                        : 'Nenhum cliente selecionado. Você pode utilizar o checkbox na tabela para selecionar os clientes desejados.'
                    }
                </Typography>
                <SpacerComponent height={10}/>
                {this.makeChipsForClientsSelected()}
                <SpacerComponent height={20}/>
                <Typography variant={'subtitle1'}>
                    <b>Atenção: Não é possível escolher clientes que já possuem
                        meta.</b>
                </Typography>
                <SpacerComponent height={10}/>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Nome</TableCell>
                                <TableCell>CPF</TableCell>
                                <TableCell>Possui Meta?</TableCell>
                                <TableCell>Media de pontos Semanal</TableCell>
                                <TableCell>Media de pontos Mensal</TableCell>
                                <TableCell>Total de pontos em 12
                                    meses</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.eligibleClients &&
                                this.makeRowTable()
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <SpacerComponent height={20}/>
                <PaginationComponent
                    total={parseInt(this.state?.pagination?.total)}
                    perPage={parseInt(this.state?.pagination?.per_page)}
                    currentPage={parseInt(this.state?.pagination?.current_page)}
                    lastPage={parseInt(this.state?.pagination?.last_page)}
                    itensVisible={2}
                    onChangePage={(page) => {
                        this.getEligibleClients({
                            page: page
                        });
                    }}/>
                <SpacerComponent height={20}/>
                <Box display="flex" justifyContent="center">
                    <Button variant={'contained'}
                            color={'primary'}
                            size={"large"}
                            fullWidth={false}
                            onClick={() => this.props.setClientsFromModal(this.getClientUuids())}>
                        Finalizar seleção
                    </Button>
                </Box>
            </div>
        );
    }
}

export default TableCampaignMetaComponent;